export default __webpack_public_path__ + "static/media/Deep Breath.d119c4f2.png";